import React, { Component } from 'react';
import Usuario from '../../../Utils/Usuario';
import { Permissions } from '../../../Utils/Permissions';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import axios from 'axios';
import './Programs.scss';
import { Configurations } from '../../../Utils/Configurations';
import Session from '../../../Utils/Session';
import update from 'immutability-helper';
import ErrorModal from '../../../Components/ErrorModal/ErrorModal';
import VideosPrograms from '../../../Components/Videos-Programs/Videos-Programs';
import qs from 'qs';
import Pagination from 'rc-pagination';



class VideosProgramsList extends Component {

    constructor(props) {
        super(props);

        this.confirmaStatusPublicacao = this.confirmaStatusPublicacao.bind(this);
        this.carregaProgramas = this.carregaProgramas.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.resetModalInfos = this.resetModalInfos.bind(this);
        this.refreshTablePrograms = this.refreshTablePrograms.bind(this);
        this.inicializaParametros = this.inicializaParametros.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.cadastraNovoPrograma = this.cadastraNovoPrograma.bind(this);
        this.toggleStatusPublicacao = this.toggleStatusPublicacao.bind(this);
        this.mudaStatusPrograma = this.mudaStatusPrograma.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.selecionaPrograma = this.selecionaPrograma.bind(this);
        this.onChangePage = this.onChangePage.bind(this);

        this.state = {
            isLoadingProgramas: false,
            openModal: false,
            nomePrograma: '',
            descricaoPrograma: '',
            urlImagem: '',
            isLoadingStatusPrograma: false,
            modalStatusPublicacao: false,
            metodoStatusPublicacao: "habilitar",
            hasError: false,
            errorMessage: '',
            limite: 20,
            listaProgramas: [],
        }
        this.Configurations = new Configurations();
    }

    componentDidMount() {
        this.carregaProgramas();
    }

    componentWillMount() {
        const _arrPerm = Usuario.getLoggedUser.permissoes.map(item => item.numero);
        const _paginas = _arrPerm.map(item => Permissions.pagesAccess(item)).flat();
        this.setState({
            paginas: _paginas,
            arrayPerm: _arrPerm,
            nomeMidia: "Vídeos",
        })
        const _permissoes = [1, 4, 10, 14, 20];
        const roles = Usuario.getLoggedUser.permissoes.map(item => item.numero);
        const found = roles.some(r => _permissoes.indexOf(r) >= 0);
        const foundStatistic = roles.some(r => [24].indexOf(r) >= 0);

        if (!found && !foundStatistic) {
            this.props.history.push({ pathname: '/permissao-negada' })
        } else {
            this.inicializaParametros(false);
            this.setState({ permissaoEdicaoVideo: found })
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.search !== this.props.location.search) {
            this.carregaProgramas();
        }
    }


    confirmaStatusPublicacao(programa, metodo) {
        this.toggleStatusPublicacao();
        this.setState({
            nomeProgramaStatusPublicacao: programa.nome,
            idVideoProgramaStatusPublicacao: programa.idVideoPrograma,
            metodoStatusPublicacao: metodo
        })
    }

    inicializaParametros(_carregaPrograma) {
        // Session.clearInfosProgramas();
        Session.clearInfosEpisodios();
        const _parametros = [];
        _parametros.push(`limite=${Session.getParametrosListaProgramas["videos"].limite}`);
        _parametros.push(`pagina=${Session.getParametrosListaProgramas["videos"].pagina}`);
        // _parametros.push(`limite=20`);
        // _parametros.push(`pagina=1`);
        this.setState({
            queryParametros: _parametros,
            pagina: Session.getParametrosListaProgramas["videos"].pagina,
            limite: Session.getParametrosListaProgramas["videos"].limite,
            // pagina: 1,
            // limite: 20,
        }, () => { if (_carregaPrograma) this.carregaProgramas({}) });
    }

    carregaProgramas() {
        this.setState({ isLoadingProgramas: true })
        const values = qs.parse(window.location.search),
            limite = parseInt(values.limite, 10),
            pagina = parseInt(values["?pagina"], 10);
        axios.get(this.Configurations.apiBasePath + `/videos/programas?pagina=${pagina}&limite=${limite}`).then(response => {
            this.setState({
                listaProgramas: response.data.data,
                paginasProgramas: response.data.paginacao.totalPaginas,
                limite: limite,
                pagina: pagina
            })
        }).catch(this.handleError).finally(() => { this.setState({ isLoadingProgramas: false }) })
    }

    refreshTablePrograms() {
        this.carregaProgramas();
    }

    toggleModal() {
        this.setState({
            openModal: !this.state.openModal,
        }, () => {
            if (!this.state.openModal) {
                this.resetModalInfos();
            }
        })
    }

    resetModalInfos() { this.setState({ nomePrograma: '', descricaoPrograma: '', urlImagem: '' }) }

    cadastraNovoPrograma() {
        this.setState({ isLoadingNovoPrograma: true })
        const _bodyNovoPrograma = {
            nome: this.state.nomePrograma,
            descricao: this.state.descricaoPrograma,
            imagem: this.state.urlImagem,
        };
        axios.post(this.Configurations.apiBasePath + `/videos/programas`, _bodyNovoPrograma).then(response => {
            this.carregaProgramas();
        }).catch(this.handleError).finally(() => {
            this.setState({ isLoadingNovoPrograma: false })
            this.toggleModal();
        })

    }

    handleOnChange(e) {
        e.preventDefault();
        const _name = e.target.name, _value = e.target.value;
        this.setState({ [_name]: _value })
    }


    toggleStatusPublicacao() {
        this.setState({ modalStatusPublicacao: !this.state.modalStatusPublicacao })
    }

    mudaStatusPrograma() {
        const _index = this.state.listaProgramas.findIndex(item => item.idVideoPrograma === this.state.idVideoProgramaStatusPublicacao);

        this.setState({ listaProgramas: update(this.state.listaProgramas, { [_index]: { loading: { $set: true } } }) })

        axios.put(this.Configurations.apiBasePath + `/videos/${this.state.idVideoProgramaStatusPublicacao}/${this.state.metodoStatusPublicacao}`).then(response => { }).catch(this.handleError).finally(() => {
            this.carregaProgramas();
            this.toggleStatusPublicacao();
            this.setState({
                isLoadingEpisodios: false,
                listaProgramas: update(this.state.listaProgramas, { [_index]: { loading: { $set: false } } })
            })
        });
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response ? err.response.data.message : 'Erro inesperado.' })
    }
    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }


    selecionaPrograma(idVideoPrograma) {
        this.props.history.push(`${this.props.match.url}/${idVideoPrograma}?pagina=1&limite=10`)
    }

    onChangePage(page) {
        this.setState({
            pagina: page,
        }, () => {
            this.props.history.push({ pathname: `/multimidia/videos`, search: `?pagina=${this.state.pagina}&limite=${this.state.limite}` })
        });
    }


    render() {
        return (
            <div className="row programs-list">
                <div className="col-12">
                    <div className="row no-gutters align-items-center">
                        <div className="col-12 col-lg-8 text-center text-lg-left">
                            <h2 className="title-1 d-none d-lg-block">{this.state.nomeMidia} - Lista de Programas</h2>
                            <h4 className="d-lg-none">{this.state.nomeMidia}</h4>
                            <h5 className="d-lg-none">Lista de Programas</h5>
                        </div>
                        <div className="col-12 col-lg-4 text-center text-lg-right">
                            <div className="row no-gutters">
                                <div className="col py-2 py-lg-0">
                                    {this.state.permissaoEdicaoVideo && (
                                        <button className="btn btn-outline-info mx-2" type="button" name="novaEdicao" onClick={this.toggleModal}>
                                            Cadastrar novo programa
                                        </button>
                                    )}
                                </div>
                            </div>
                            {this.state.permissaoEdicaoVideo && (
                                    <button className="btn btn-outline-primary mx-2 mt-3" type="button" name="destaques" onClick={() => this.props.history.push({pathname: 'destaques/videos'})}>
                                        Destaques
                                    </button>
                            )}
                        </div>
                    </div>
                </div>
                <div className={`col-12`}>
                    <div className="row no-gutters">
                        <div className={`col-12`}>
                            <div className="row no-gutters">
                                <div className={`col-12 text-center text-lg-left`}>
                                    <p className="py-2 m-0">Clique no programa para obter informações sobre os episódios.</p>
                                </div>
                                {this.state.isLoadingProgramas ? (
                                    <div className="col-12 text-center px-3 py-5">
                                        <div className="spinner-border text-primary" role="status" />
                                    </div>
                                ) : (
                                    <div className="col-12">
                                        <div className="row lista-programas">
                                            {!!this.state.listaProgramas && this.state.listaProgramas.map((item, index) => {
                                                return (
                                                    <div className="col-12 py-2" key={index}>
                                                        <VideosPrograms
                                                            item={item}
                                                            confirmaStatusPublicacao={this.confirmaStatusPublicacao}
                                                            selecionaPrograma={this.selecionaPrograma}
                                                            permissaoEdicaoVideo={this.state.permissaoEdicaoVideo}
                                                        />
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    {!this.state.isLoadingProgramas && this.state.listaProgramas && this.state.listaProgramas.length > 0 && (
                        <div className="col-12 mt-2 px-0">
                            <div className="paginacao-programas">
                                <Pagination onChange={this.onChangePage} current={this.state.pagina} total={this.state.paginasProgramas * this.state.limite} pageSize={this.state.limite} />
                            </div>
                        </div>
                    )}
                </div>

                <Modal className="modal-new-edition" isOpen={this.state.openModal} toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal}>
                        <div className="row no-gutters">
                            <div className="col-12 d-none d-lg-block">
                                Cadastro de Novo Programa - {this.state.nomeMidia}
                            </div>
                            <div className="col-12 d-lg-none text-center">
                                <h5>Cadastro de Novo Programa</h5>
                            </div>
                            <div className="col-12 d-lg-none text-center">
                                <h6>{this.state.nomeMidia}</h6>
                            </div>
                        </div>
                    </ModalHeader>
                    <ModalBody>
                        <div className="row no-gutters align-items-end">
                            <div className="col-12 col-lg-12 px-1 py-1">
                                <label>Nome do programa:</label>
                                <input autoComplete="off" name="nomePrograma" className="form-control input-edicao" type="text" value={this.state.nomePrograma} onChange={this.handleOnChange} />
                            </div>
                            <div className="col-12 col-lg-12 px-1 py-1">
                                <label>Descrição do programa:</label>
                                <input autoComplete="off" name="descricaoPrograma" className="form-control input-edicao" type="text" value={this.state.descricaoPrograma} onChange={this.handleOnChange} />
                            </div>
                            <div className="col-12 col-lg-12 px-1 py-1">
                                <label>Url para imagem de capa:</label>
                                <input autoComplete="off" name="urlImagem" className="form-control input-edicao" type="text" value={this.state.urlImagem} onChange={this.handleOnChange} />
                            </div>
                            <div className="col-12 col-lg-12 pt-3 text-center text-lg-right">
                                {this.state.isLoadingNovoPrograma ? (
                                    <div className="spinner-border text-primary" role="status" />
                                ) : (
                                    <button onClick={this.cadastraNovoPrograma} disabled={this.state.nomePrograma.trim() === ''} className="btn btn-outline-success">cadastrar programa</button>
                                )}
                            </div>
                        </div>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.modalStatusPublicacao} toggle={this.toggleStatusPublicacao}>
                    <ModalHeader toggle={this.toggleStatusPublicacao}>Mudança de Status do Programa</ModalHeader>
                    <ModalBody>
                        {this.state.metodoStatusPublicacao === 'habilitar' ? (
                            <p className="m-0">{`Deseja confirmar a publicação do programa ${this.state.nomeProgramaStatusPublicacao}?`}</p>
                        ) : (
                            <p className="m-0">{`Deseja desabilitar o programa ${this.state.nomeProgramaStatusPublicacao}?`}</p>
                        )}

                    </ModalBody>
                    <ModalFooter>
                        {this.state.isLoadingStatusPrograma ? (
                            <div className="spinner-border text-primary" role="status" />
                        ) : (
                            <Button disabled={this.state.isLoadingStatusPrograma} color={`${this.state.metodoStatusPublicacao === 'habilitar' ? `success` : `danger`}`} onClick={this.mudaStatusPrograma}>confirmar</Button>
                        )}
                        {' '}<Button color="secondary" onClick={() => this.setState({ modalStatusPublicacao: !this.state.modalStatusPublicacao })}>voltar</Button>
                    </ModalFooter>
                </Modal>
                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                // direcionaURL={'/conteudo'}
                // goBack={true}
                />
            </div >
        )
    }
}

export default VideosProgramsList;